export const validatePassword = (password) => {
  return {
    length: password.length >= 10,
    uppercase: /[A-Z]/.test(password),
    lowercase: /[a-z]/.test(password),
    special: /[!@#$%^&*(),.?":{}|<>]/.test(password)
  }
}

export const isPasswordValid = (validations) => {
  return Object.values(validations).every(Boolean)
}
